module.exports = __webpack_public_path__ + "static/media/a2.5c11ce07.jpg";